import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
    CustomRoleDetail,
    CustomRoleSummary,
    CustomRoleUpsertRequest,
    PermissionCatalog,
    StitchedRole
} from './tenant-role.model';

@Injectable({
    providedIn: 'root'
})
export class TenantRoleService {
    private readonly baseUrl: string;

    constructor(private http: HttpClient) {
        this.baseUrl = `${environment.restApiUrl}tenant-roles`;
    }

    getRolesDirectory(): Observable<CustomRoleSummary[]> {
        return this.http.get<CustomRoleSummary[]>(`${this.baseUrl}/directory`);
    }

    getStandardRoles(): Observable<StitchedRole[]> {
        return this.http.get<StitchedRole[]>(`${this.baseUrl}/standard`);
    }

    getPermissionsCatalog(): Observable<PermissionCatalog[]> {
        return this.http.get<PermissionCatalog[]>(`${this.baseUrl}/permissions-catalog`);
    }

    getRoleDetail(roleId: number): Observable<CustomRoleDetail> {
        return this.http.get<CustomRoleDetail>(`${this.baseUrl}/custom/${roleId}`);
    }

    createCustomRole(request: CustomRoleUpsertRequest): Observable<CustomRoleDetail> {
        return this.http.post<CustomRoleDetail>(`${this.baseUrl}/custom`, request);
    }

    updateCustomRole(roleId: number, request: CustomRoleUpsertRequest): Observable<CustomRoleDetail> {
        return this.http.put<CustomRoleDetail>(`${this.baseUrl}/custom/${roleId}`, request);
    }

    deleteCustomRole(roleId: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/custom/${roleId}`);
    }
}

